// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.CancelRenterPaymentSubscriptionWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  CancelRenterPaymentSubscriptionWebApiRequestDto,
  CancelRenterPaymentSubscriptionWebApiResponseDto,
} from '../..';

export const CancelRenterPaymentSubscriptionWebApiHandler_cancelRenterPaymentSubscription_Path =
  '/api/web/v1/cancelRenterPaymentSubscription';

/**
 * Cancel Renter's Payment Subscription
 */
export const CancelRenterPaymentSubscriptionWebApiHandler_cancelRenterPaymentSubscription = (
  postData: CancelRenterPaymentSubscriptionWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    CancelRenterPaymentSubscriptionWebApiRequestDto,
    CancelRenterPaymentSubscriptionWebApiResponseDto
  >(
    {
      endpoint: CancelRenterPaymentSubscriptionWebApiHandler_cancelRenterPaymentSubscription_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
